import { useState, useEffect } from "react";
import { Row, Col, Carousel } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import VehicleCard from "../VehicleCard";
import React from "react";
import { scroller } from "react-scroll";
import FinancingCarousel from "./FinancingCarousel";
import useFinanciaciones from "../../config/useFinanciaciones";
import loading from "../../assets/loading.svg";
import { saveTrackingParams, getUtmsQueryString } from "../../utils/utmTracker";
import { saveUtmParams } from "../../config/whatsappConfig";

const VehicleList = ({ vehicles }) => {
  const [tipoSearch, setTipoSearch] = useState("todos");
  const [tipoToUse, setTipoToUse] = useState("todos");
  const [filtrados, setFiltrados] = useState(vehicles);

  let history = useHistory();
  let { tipo } = useParams();

  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();

  useEffect(() => {
    if (
      tipo !== "todos" &&
      tipo !== "convencional" &&
      tipo !== "plan" &&
      tipo !== "preventa" &&
      tipo !== "adjudicado"
    ) {
      saveTrackingParams();
      saveUtmParams();
      history.push(`/todos${getUtmsQueryString()}`);
    }
  }, []);

  useEffect(() => {
    if (tipo === undefined) {
      setTipoToUse("todos");
    } else {
      setTipoToUse(tipo);
    }
  }, [tipo]);

  useEffect(() => {
    setTipoSearch(tipoToUse);
  }, [tipoToUse]);

  const handleTipo = (e) => {
    setTipoSearch(e);
    saveTrackingParams();
    saveUtmParams();
    scroller.scrollTo("scroll-click", { smooth: true, duration: 500 });
  };

  //FILTRAR LOS VEHICULOS
  useEffect(() => {
    if (tipoSearch === "preventa") {
      setFiltrados(vehicles.filter((item) => item.preventa.habilitado === true));
    }

    if (tipoSearch === "adjudicado") {
      setFiltrados(vehicles.filter((item) => item.adjudicado.habilitado === true));
    }
    if (tipoSearch === "plan") {
      setFiltrados(vehicles.filter((item) => item.plan.habilitado === true));
    }

    if (tipoSearch === "convencional") {
      setFiltrados(vehicles.filter((item) => item.convencional.habilitado === true));
    }

    if (tipoSearch === "todos") {
      setFiltrados(vehicles);
    }
  }, [tipoSearch, vehicles]);

  const filtradosConvencional = vehicles.filter((item) => item?.convencional?.habilitado === true);

  const filtradosPlan = vehicles.filter((item) => item?.plan?.habilitado === true);

  const filtradosPreventa = vehicles.filter((item) => item?.preventa?.habilitado === true);

  const filtradosAdjudicados = vehicles.filter((item) => item?.adjudicado?.habilitado === true);

  //console.log(filtradosAdjudicados);

  // aqui guardamos los datos de utms

  /*sessionStorage.setItem('saludo', 'Bienvenidos asessionStorage');
  valor =sessionStorage.getItem('saludo');
  */

  return (
    <>
      <Row id="scroll-click">
        <Col md={12} className="text-center">
          <h1 className="titMainPortada pt-5 pb-5 text-center">Subite a tu 0km en Montironi</h1>
        </Col>
      </Row>
      <Row className="pb-5" id="todos">
        <Col className="d-flex justify-content-center">
          <button
            type="button"
            className={`btn btn-blue m-2 ${
              tipoSearch !== "plan" && tipoSearch !== "convencional" && tipoSearch !== "adjudicados" && "active"
            }`}
            onClick={() => handleTipo("todos")}
          >
            Ver todo
          </button>

          <button
            type="button"
            className={`btn btn-blue m-2 ${tipoSearch === "convencional" && "active"}`}
            onClick={() => handleTipo("convencional")}
          >
            Venta directa
          </button>
          <button
            type="button"
            className={`btn btn-blue m-2 ${tipoSearch === "plan" && "active"}`}
            onClick={() => handleTipo("plan")}
          >
            Fiat Plan
          </button>

          {filtradosAdjudicados && filtradosAdjudicados.length > 0 && (
            <button
              type="button"
              className={`btn btn-blue m-2 ${tipoSearch === "adjudicados" && "active"}`}
              onClick={() => handleTipo("adjudicados")}
            >
              Adjudicados
            </button>
          )}
        </Col>
      </Row>
      {tipoSearch === "convencional" || tipoSearch === "todos" ? (
        <div id="convencional">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">VENTA DIRECTA</h2>
          </Row>
          <Row>
            <Col>
              {loadingFinanciaciones ? (
                <Row className="d-flex justify-content-center mb-5">
                  <img src={loading} alt="Cargando..." style={{ width: 100, height: 100 }} />
                </Row>
              ) : financiaciones && financiaciones.length > 0 ? (
                <FinancingCarousel financiaciones={financiaciones} />
              ) : null}
            </Col>
          </Row>
          <Row className="d-flex">
            {filtradosConvencional && filtradosConvencional.length > 0 ? (
              filtradosConvencional
                .sort((a, b) => a.convencional.prioridad - b.convencional.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosConvencional}
                      nombreTipo="convencional"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}

      {tipoSearch === "plan" || tipoSearch === "todos" ? (
        <div className={tipoSearch === "plan" ? null : "mt-5"} id="plan">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">FIAT PLAN</h2>
          </Row>
          <Row className="d-flex">
            {filtradosPlan && filtradosPlan.length > 0 ? (
              filtradosPlan
                .sort((a, b) => a.plan.prioridad - b.plan.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosPlan}
                      nombreTipo="plan"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}

      {tipoSearch === "adjudicados" || tipoSearch === "todos" ? (
        <div className={tipoSearch === "plan" ? null : "mt-5"} id="plan">
          {filtradosAdjudicados && filtradosAdjudicados.length > 0 ? (
            <>
              {" "}
              <Row className="d-flex">
                <h2 className="titulo-categorias-home">PLANES ADJUDICADOS</h2>
              </Row>
              <Row className="d-flex">
                {filtradosAdjudicados
                  .sort((a, b) => a.adjudicado.prioridad - b.adjudicado.prioridad)
                  .map((item, index) => (
                    <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                      <VehicleCard
                        info={item}
                        tipo={tipoSearch}
                        filtrados={filtradosAdjudicados}
                        nombreTipo="adjudicado"
                        todosLosVehiculos={vehicles}
                      />
                    </Col>
                  ))}
              </Row>
            </>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default VehicleList;

